// Filtros do Catálogo de Transportadoras (PO1-3856 + PO1-3857): opções dos
// selects, rótulos em português dos valores da API e a montagem da query de
// GET /transportadoras/catalogo. Sem React. Node 12: sem `?.`/`??`.

export const REGIOES = ["Norte", "Nordeste", "Centro-Oeste", "Sudeste", "Sul"];
export const REGIAO_OPTIONS = [{ value: "", label: "Todas as regiões" }].concat(REGIOES.map((r) => ({ value: r, label: r })));

// Categoria do conector (coluna Conector.Segmento no backend).
export const ROTULO_CATEGORIA = {
  agregador: "Agregador de frete",
  ecommerce: "E-commerce / encomendas",
  apps: "Entrega rápida (app)",
  api_propria: "API da transportadora",
  tms: "Pelo sistema da transportadora",
  sem_conector: "Sem conector",
};
export const CATEGORIA_OPTIONS = ["agregador", "ecommerce", "apps", "api_propria", "tms", "sem_conector"].map((value) => ({
  value,
  label: ROTULO_CATEGORIA[value],
}));

// Sistema (TMS) da transportadora; só faz sentido com a categoria `tms`.
export const ROTULO_SISTEMA = { ssw: "SSW", esl: "ESL Cloud", brudam: "Brudam", track3r: "TRACK3R" };
export const SISTEMA_OPTIONS = ["ssw", "esl", "brudam", "track3r"].map((value) => ({ value, label: ROTULO_SISTEMA[value] }));

// Modalidade derivada do CNAE principal.
export const ROTULO_MODALIDADE = {
  aereo: "Aéreo / expresso",
  rodoviario: "Rodoviário",
  courier: "Courier / encomendas",
  agenciamento: "Agenciamento / OTM",
  armazenagem: "Armazenagem / logística",
  nao_informado: "Não informado",
};
export const MODALIDADE_OPTIONS = ["aereo", "rodoviario", "courier", "agenciamento", "armazenagem", "nao_informado"].map((value) => ({
  value,
  label: ROTULO_MODALIDADE[value],
}));

export const FILTROS_VAZIOS = { regiao: "", categorias: [], sistemas: [], modalidades: [], ufOrigem: "", ufDestino: "" };

const temLista = (lista) => Array.isArray(lista) && lista.length > 0;
const listaParaQuery = (lista) => (temLista(lista) ? lista.join(",") : undefined);

// Quantos filtros do painel estão ativos (cada select conta uma vez; a rota
// conta uma vez mesmo com origem e destino preenchidos).
export function contarFiltros(f) {
  const filtros = f || FILTROS_VAZIOS;
  return (
    (filtros.regiao ? 1 : 0) +
    (temLista(filtros.categorias) ? 1 : 0) +
    (temLista(filtros.sistemas) ? 1 : 0) +
    (temLista(filtros.modalidades) ? 1 : 0) +
    (filtros.ufOrigem || filtros.ufDestino ? 1 : 0)
  );
}

// Parâmetros do painel para a API: listas separadas por vírgula, vazios como
// undefined (o axios omite), `foraCarteira` só quando ligado.
export function montarParametros({ filtros, foraCarteira } = {}) {
  const f = filtros || FILTROS_VAZIOS;
  return {
    regiao: f.regiao || undefined,
    categoria: listaParaQuery(f.categorias),
    sistema: listaParaQuery(f.sistemas),
    modalidade: listaParaQuery(f.modalidades),
    ufOrigem: f.ufOrigem || undefined,
    ufDestino: f.ufDestino || undefined,
    foraCarteira: foraCarteira ? "1" : undefined,
  };
}

// Rótulo do selo de cobertura na rota: comprovada ganha a contagem de CT-e
// (12 meses, ou o histórico quando não houve emissão recente); declarada é só
// o nome; sem informação (ou sem rota) não tem selo.
export function rotuloCobertura(cobertura) {
  if (!cobertura || !cobertura.nivel) return null;
  if (cobertura.nivel === "comprovada") {
    const qt12m = Number(cobertura.qtCte12m) || 0;
    const qtTotal = Number(cobertura.qtCte) || 0;
    if (qt12m > 0) return `Comprovada · ${qt12m} CT-e em 12 meses`;
    if (qtTotal > 0) return `Comprovada · ${qtTotal} CT-e no histórico`;
    return "Comprovada";
  }
  if (cobertura.nivel === "declarada") return "Declarada";
  return null;
}
